type SchemaShape =
  | {
      type?: 'array' | 'enum' | 'object' | 'string' | 'number' | 'boolean';
      title?: string;
      description?: string;
      enum?: string[];
      items?: SchemaShape;
      properties?: Record<string, SchemaShape>;
      required?: Array<string>;
      additionalProperties?: false | SchemaShape;
      default?: Record<string, null | boolean | Array<unknown>>;
      $ref?: string;
    }
  | { anyOf: SchemaShape[] }
  | { type: 'null' };

function parseAndRewriteHeaderSchema(
  headersEntry: SchemaShape,
  allSubgraphs: string[],
) {
  if (
    'anyOf' in headersEntry ||
    headersEntry.type === 'null' ||
    !headersEntry.properties
  ) {
    return headersEntry;
  }

  // get the properties value for "all" subgraphs so we can copy it to each
  // individual subgraph
  const headerProperties = headersEntry.properties.all;

  const subgraphProperties: Record<string, SchemaShape> = allSubgraphs.reduce(
    (currProperties, subgraphName) => ({
      ...currProperties,
      [subgraphName]: headerProperties,
    }),
    {},
  );

  return {
    ...headersEntry,
    properties: {
      all: headerProperties,
      subgraphs: {
        properties: subgraphProperties,
        type: 'object',
      },
    },
  };
}

export function computeJsonSchema(
  configSchema: string,
  allSubgraphs: string[],
): Record<string, unknown> {
  const parsedSchema = JSON.parse(configSchema) as Record<string, SchemaShape>;

  const updatedProperties = Object.entries(parsedSchema.properties ?? {}).map(
    ([key, entry]: [string, SchemaShape]) => {
      if (key === 'headers') {
        const rewrittenHeadersSchema = parseAndRewriteHeaderSchema(
          entry,
          allSubgraphs,
        );

        return [key, rewrittenHeadersSchema];
      }
      return [key, entry];
    },
  );

  return {
    ...parsedSchema,
    properties: Object.fromEntries(updatedProperties),
  };
}
